<template>
  <nav
    class="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg"
  >
    <div
      class="container px-4 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
      >
        <router-link
          class="text-bgbb-y font-bold text-sm leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase"
          to="/"
        >
          BGBB.io
        </router-link>
        <button
          class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          v-on:click="setNavbarOpen"
        >
          <i class="text-bgbb-y fas fa-bars"></i>
        </button>
      </div>
      <div
        class="lg:flex flex-grow items-center bg-dark-bgbbnav lg:bg-transparent lg:shadow-none"

        :class="[navbarOpen ? 'block rounded shadow-lg' : 'hidden']"
        id="example-navbar-warning"
      >
        

<ul class="flex flex-col lg:flex-row list-none mr-auto">
<li class="flex items-center">

 <a class="text-white px-3 py-2 flex items-center text-bases"  href="https://github.com/BGBB-token/papers/raw/main/White_Paper_V2.0.pdf" >
<i class="text-white text-lg leading-lg mr-2"/> White Paper</a>

</li></ul>

<ul class="flex flex-col lg:flex-row list-none mr-auto">
<li class="flex items-center">
<a class="text-white px-3 py-2 flex items-center text-base" href="https://github.com/BGBB-token/papers/raw/6325b50fcf238cf8c3d540cc42e58d26f09fecf6/Technical_Paper_V1.0.pdf" >
<i  class="text-white text-lg leading-lg mr-2" /> Technical Paper   </a>
</li></ul>

<ul class="flex flex-col lg:flex-row list-none mr-auto">
<li class="flex items-center">
<a class="text-white px-3 py-2 flex items-center text-base" href="/#mission"> 
<i  class="text-white text-lg leading-lg mr-2"  />Mission</a>
 </li></ul>

<ul class="flex flex-col lg:flex-row list-none mr-auto">
<li class="flex items-center">
<a class="text-white px-specialmenu py-2 flex items-center text-base" href="/staking">
<i  class="text-white text-lg leading-lg mr-2"  />Staking </a> 
<span class="text-bgbb-y text-xs">[soon]</span>
</li></ul>
            

<ul class="flex flex-col lg:flex-row list-none mr-auto">
<li class="flex items-center">
<a class="text-white px-specialmenu2 py-2 flex items-center text-base" href="/NFT-Marketplace">
<i  class="text-white text-lg leading-lg mr-2"  />NFT Marketplace</a> 
<span class="text-bgbb-y text-xs">[soon]</span>
 </li></ul>

        
        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <li class="flex items-center">
            <!-- <PagesDropdown /> -->
          </li>    
          
          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://discord.gg/7bVKAPYEkq"
              target="_blank"
            >
              <i class="text-white fab fa-discord text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Discord</span>
            </a>
          </li>

  <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://t.me/BGBB_Token"
              target="_blank"
            >
              <i class="text-white fab fa-telegram text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Telegram</span>
            </a>
          </li>

<li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://medium.com/@bgbb_token"
              target="_blank"
            >
              <i class="text-white fab fa-medium text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Medium</span>
            </a>
          </li>

          <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://twitter.com/BgbbToken"
              target="_blank"
            >
              <i class="text-white fab fa-twitter text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">Tweet</span>
            </a>
          </li>

           <li class="flex items-center">
            <a
              class="text-white px-2 py-2 flex items-center text-xs uppercase font-bold"
              href="https://github.com/BGBB-token"
              target="_blank"
            >
              <i class="text-white fab fa-github text-lg leading-lg" />
              <span class="lg:hidden inline-block ml-2">GitHub</span>
            </a>
          </li>
          
          <li class="flex items-center">
            <button
              class="shadow-2xl bg-dark text-dark bg-bgbb-y text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
              type="button"
            >
             connect wallet
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
// import PagesDropdown from "@/components/Dropdowns/PagesDropdown.vue";
export default {
  data() {
    return {
      navbarOpen: false,
    };
  },
  methods: {
    setNavbarOpen: function () {
      this.navbarOpen = !this.navbarOpen;
    },
  },
  components: {
    // PagesDropdown,
  },
};
</script>